exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Zh_5SnNJPs1eBDsxLM3WQ {\n  font-style: italic;\n  color: #8993a4;\n  border: solid 1px transparent;\n}\n._2Zh_5SnNJPs1eBDsxLM3WQ:hover {\n  border: solid 1px #8993a4;\n}\n._2ofubbpuA-T2EyRIcevqcR {\n  border: solid 2px transparent;\n  max-width: 700px;\n}\n._2ofubbpuA-T2EyRIcevqcR ._2gLqswMaiOFNj7jdMfLuBH {\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n  font-size: inherit;\n  outline: none;\n  border: none;\n  background-color: transparent;\n}\n", ""]);

// Exports
exports.locals = {
	"placeholder": "_2Zh_5SnNJPs1eBDsxLM3WQ",
	"titleWrapper": "_2ofubbpuA-T2EyRIcevqcR",
	"title": "_2gLqswMaiOFNj7jdMfLuBH"
};